const IDLE_FALLBACK_DELAY_MS = 2_000

export function runWhenIdle(
    callback: () => void,
    { timeoutMs }: { timeoutMs: number }
): () => void {
    if (typeof window.requestIdleCallback === "function") {
        const id = window.requestIdleCallback(callback, { timeout: timeoutMs })
        return () => window.cancelIdleCallback(id)
    }
    const id = window.setTimeout(
        callback,
        Math.min(IDLE_FALLBACK_DELAY_MS, timeoutMs)
    )
    return () => window.clearTimeout(id)
}
